module.exports = __webpack_public_path__ + "static/media/Logo.1465689c.png";